module.exports = __webpack_public_path__ + "static/img/wuxian-2.0cfc62f5.png";